// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DataCenterIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DataCenterIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 5h1.5v1.5h-1.5z" />
      <path d="M12 8H8v1.25h4z" />
      <path d="M8 10.5h4v1.25H8z" />
      <path d="M12 13H8v1.25h4z" />
      <path d="M5.25 16v.75a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V16h2.75a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2.75V3.25a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1V4H2.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1zm1.5.25V3.75h6.5v12.5zm-1.5-1.75H3v-9h2.25zm9.5 0v-9H17v9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DataCenterIcon = /* @__PURE__ */ Object.assign(
  DataCenterIconComponent,
  { displayName: 'DataCenterIcon' },
);
